"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    install: (Vue, { apiKey }) => {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        document.body.appendChild(script);
    },
};
